var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BackgroundFixed',[_c('SuccessIcon',[_vm._v(" Check your email for the verification link. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }